import { ArticleOptionsServices } from '../../global';

const INCIDENT_NAME = 'Offers Link Mask Incident';

export class HtmlOffersPageLinkReplacer {
    private readonly componentRootElementClass: string;

    constructor(componentRootElementClass: string) {
        this.componentRootElementClass = componentRootElementClass;
    }

    public initializeOffersLink() {
        if (o_product.data.enteredArticleNumberAndPromotion) {
            this.generateAndReplaceOffersPageLink({ services: [] });
        }
    }

    public generateAndReplaceOffersPageLink(articleOptionsServices: ArticleOptionsServices) {
        const componentRootElement = this.getRootElement();
        if (!componentRootElement) {
            return;
        }

        const offersLinkElement = this.findOffersLinkElement(componentRootElement);
        if (!offersLinkElement) {
            throw new Error(`${INCIDENT_NAME}: could not find link element`);
        }

        const offersBaseUrl = this.getOffersBaseUrl(componentRootElement);
        if (!offersBaseUrl) {
            throw new Error(`${INCIDENT_NAME}: no offers base url set`);
        }

        const newOffersLink = this.createNewOffersLink(offersBaseUrl, articleOptionsServices);
        this.replaceOffersLink(newOffersLink, offersLinkElement);
    }

    private createNewOffersLink(offersBaseUrl: string, articleOptionsData: ArticleOptionsServices) {
        const selectedServices = articleOptionsData.services.map(service => service.uuid).join(',');
        const offersUrlParameter = new URLSearchParams();
        const hasEnteredArticleNumberWithPromotion = o_product.data.enteredArticleNumberAndPromotion;

        if (hasEnteredArticleNumberWithPromotion) {
            offersUrlParameter.append('enteredArticleNumberAndPromotion', `${hasEnteredArticleNumberWithPromotion}`);
        }
        if (selectedServices) {
            offersUrlParameter.append('selectedServices', `${selectedServices}`);
        }
        if (!offersUrlParameter.toString()) {
            return offersBaseUrl;
        }

        return `${offersBaseUrl}&${offersUrlParameter.toString()}`;
    }

    private replaceOffersLink(offersLink: string, offersLinkElement: Element) {
        offersLinkElement.setAttribute('base64-href', btoa(offersLink));
    }

    private getRootElement(): Element | null {
        return document.querySelector(this.componentRootElementClass);
    }

    private findOffersLinkElement(componentRootElement: Element) {
        return componentRootElement.querySelector('.js_pdp_competing-offers__link');
    }

    private getOffersBaseUrl(componentRootElement: Element): string | null {
        return componentRootElement.getAttribute('data-offers-base-url');
    }
}
